// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file morfi/v1/cmd/outcome_added.proto (package morfi.v1.cmd, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file morfi/v1/cmd/outcome_added.proto.
 */
export const file_morfi_v1_cmd_outcome_added: GenFile = /*@__PURE__*/
  fileDesc("CiBtb3JmaS92MS9jbWQvb3V0Y29tZV9hZGRlZC5wcm90bxIMbW9yZmkudjEuY21kItIBCgxPdXRjb21lQWRkZWQSCgoCdHMYASABKAMSFQoNbWFya2V0X3B1YmtleRgCIAEoCRIVCg1zdWdnZXN0aW9uX2lkGAMgASgJEhYKDm91dGNvbWVfcHVia2V5GAQgASgJEhMKC2ZpbmFsX2xhYmVsGAUgASgJEhQKDGZpbmFsX3RpY2tlchgGIAEoCRIXCg9maW5hbF9pbWFnZV91cmwYByABKAkSGgoNb3V0Y29tZV9pbmRleBgIIAEoDUgAiAEBQhAKDl9vdXRjb21lX2luZGV4YgZwcm90bzM");

/**
 * @generated from message morfi.v1.cmd.OutcomeAdded
 */
export type OutcomeAdded = Message<"morfi.v1.cmd.OutcomeAdded"> & {
  /**
   * @generated from field: int64 ts = 1;
   */
  ts: bigint;

  /**
   * @generated from field: string market_pubkey = 2;
   */
  marketPubkey: string;

  /**
   * @generated from field: string suggestion_id = 3;
   */
  suggestionId: string;

  /**
   * @generated from field: string outcome_pubkey = 4;
   */
  outcomePubkey: string;

  /**
   * @generated from field: string final_label = 5;
   */
  finalLabel: string;

  /**
   * @generated from field: string final_ticker = 6;
   */
  finalTicker: string;

  /**
   * @generated from field: string final_image_url = 7;
   */
  finalImageUrl: string;

  /**
   * @generated from field: optional uint32 outcome_index = 8;
   */
  outcomeIndex?: number | undefined;
};

/**
 * Describes the message morfi.v1.cmd.OutcomeAdded.
 * Use `create(OutcomeAddedSchema)` to create a new message.
 */
export const OutcomeAddedSchema: GenMessage<OutcomeAdded> = /*@__PURE__*/
  messageDesc(file_morfi_v1_cmd_outcome_added, 0);

